import React from 'react';
import { PropTypes } from 'prop-types';
import { SurveyWrapper, StyleWrapper } from './styles';
import { FormAssembly } from '../form';

const Survey = ({ contentfulData }) => (
  <SurveyWrapper>
    <StyleWrapper>
      <FormAssembly isSurvey contentfulData={contentfulData} />
    </StyleWrapper>
  </SurveyWrapper>
);

Survey.propTypes = {
  contentfulData: PropTypes.object.isRequired,
};

export default Survey;
